export default __webpack_public_path__ + "static/media/icon-very-happy-face-empty.8b86d8ff.svg";